import {get, post} from '~/utils/request';

export function checkFineMember(data){
  return get('/MeData/CheckFineMember', data);
}

export function getUserDataID(data){
  return post('/MeData/GetUserDataID', data);
}